var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/moral-new.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-14ee37bb!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/moral-new.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MoralNew.vue
// module id = 653
// module chunks = 1